module.exports = __webpack_public_path__ + "static/img/recognition1.248b1e09.png";